export type AnalyticsProperties = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/** Consent-aware, decision-oriented analytics wrapper. */
export const trackEvent = (name: string, properties: AnalyticsProperties = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  const cleanProperties = Object.fromEntries(
    Object.entries(properties).filter(([, value]) => value !== undefined),
  );
  window.gtag('event', name, cleanProperties);
};
